import { render, staticRenderFns } from "./OrganizationSettingsSocials.vue?vue&type=template&id=0d65760e&scoped=true"
import script from "./OrganizationSettingsSocials.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsSocials.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsSocials.vue?vue&type=style&index=0&id=0d65760e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d65760e",
  null
  
)

export default component.exports